const showNavTabByIndex = function(navTabsTarget, index) {
    var navTabsContainers = document.getElementsByClassName(navTabsTarget);

    if (navTabsContainers.length > 0) {

        // console.log(navTabsContainers[0]);

        var navTabsContainer = navTabsContainers[0].getElementsByTagName('A');

        if (typeof(navTabsContainer) != 'undefined' && navTabsContainer != null) {

            Array.from(navTabsContainer).map(
                function (tab)  {
                    new BSN.Tab( tab, {height: true} )
                }
            );

            // console.log(navTabsContainer);

            var targetedTab = navTabsContainer[index];

            var targetedTabInit = targetedTab.Tab;

            targetedTabInit.show();

            targetedTab.addEventListener('show.bs.tab', function(event) {
                // Scroll to nav-tabs after tab is rendered (shown)
                navTabsContainers[0].scrollIntoView({behavior: 'smooth'});
            }, false);
        }
    }
}

// Find all CTAs with "data-nav-tabs-target" attribute
document.querySelectorAll('[data-nav-tabs-target]').forEach(function(cta) {

    var ctaTarget = cta.dataset.navTabsTarget, // Nav tabs class (container)
        ctaTargetIndex = cta.dataset.navTabsTabIndexTarget; // Targeted nav tabs - Tab index

    // Add event click listeners on CTA
    cta.addEventListener('click', function (e) {
        showNavTabByIndex(ctaTarget, ctaTargetIndex);
    });
});
